import React, { useEffect, useState } from "react";
import { Button, Form, AutoComplete, Input } from "antd";
 
import { QBO_APP_BASE_URL } from "../../utils/constants";
import { DownOutlined } from "@ant-design/icons";
import bg_onboarding from "../../images/icons/bg_onboarding.png";

function Step1(props) {
  const { data, onFinish, formData } = props;
  const [optionsOfDepositeAccounts, setOptionsOfDepositeAccounts] = useState();
 

  const [form] = Form.useForm();

  useEffect(() => {
    if (data) {
      setOptionsOfDepositeAccounts(data.deposite);
    }
  }, [data]);

  function connectQBO(e) {
    window.open(QBO_APP_BASE_URL + "/oauthlogin.php?companyId=" + 1, "_self");
  }

  

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div
      className="
      h-screen w-full  bg-cover bg-center lg:bg-cover lg:bg-no-repeat bg-no-repeat
      grid grid-cols-12"
      style={{
        backgroundImage: `url(${bg_onboarding})`,
        flexBasis: 0,
        flexGrow: 3,
      }}
    >
      {/* 1st half */}
      <div className="col-span-6 ">
        {/* <img className="w-full h-screen" src={LeftSide_Step1} alt="step1 image"/> */}
      </div>

      {/* 2nd half */}
      {data && (
        <div className="col-span-6 flex justify-center w-full ">
          <div className="w-full mx-10 h-full flex items-center ">
            <Form
              form={form}
              name="deposite"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              layout="vertical"
              initialValues={{
                depositeAccount: formData.deposit_account,
              }}
            >
              <div className="border-2 h-350 rounded-lg bg-white font-raleway">
                <div className="mx-5">
                  <p className="font-raleway font-normal text-xs h-4 mt-6">Step 1/4</p>
                  <h1 className="font-raleway font-bold text-3xl h-4 mt-4 leading-6">
                  Set up Deposit Account
                  </h1>
                  <p className="text-xs mt-3 leading-6 ">
                  Select your QuickBooks Online account to record Current Deposit Liabilities

                  </p>

                  
                  <Form.Item
                  className="ant-col marginb"
                    name="depositeAccount"
                      label="Deposit Account"
                    // label={ 
                    //   <p  className="font-raleway pb-4">"System Pressurized"</p>
                      
                    // }
                    style={{marginTop:'25px' }}
                    rules={[
                      {
                        required: true,
                        message: "Deposit account is required",
                      },

                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (
                            !value ||
                            optionsOfDepositeAccounts.find(
                              (o) =>
                                o.value === getFieldValue("depositeAccount")
                            )
                          ) {
                            return Promise.resolve();
                          }

                          return Promise.reject(
                            new Error("Select Valid Deposite Account!")
                          );
                        },
                      }),
                    ]}
                  >
                    <AutoComplete
                      style={{
                        width: 310,
                      }}
                      options={optionsOfDepositeAccounts}
                      onChange={(value) => {}}
                      onSelect={(value) => {}}
                    >
                      <Input
                        value={"optionsOfDepositeAccounts"}
                        placeholder="Select deposite account"
                        suffix={<DownOutlined />}
                         className="font-raleway"
                      />
                    </AutoComplete>
                  </Form.Item>

                  <p className="text-xs text-black_text_light font-normal font-raleway leading-5 mt-4">
                  Please ensure that the account you select exists in your QuickBooks Online company. This account is usually a current asset account..
                  </p>

                  <div className="flex gap-6 justify-end mt-8 mb-9">
                    <Button className="w-24 h-8" type="primary" htmlType="submit">
                      Next
                    </Button>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Step1;
